var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "notification-container clickable",
      class: { "no-lobby": !_vm.hasLobby, popover: _vm.popover },
    },
    [
      _vm.hasLobby
        ? _c(
            "div",
            {
              staticClass: "lobby-trigger",
              on: {
                click: function ($event) {
                  return _vm.redirectToLobby()
                },
              },
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/images/lobby.webp") },
              }),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "scheduleTrigger",
          staticClass: "schedule-trigger",
          on: { click: _vm.openSchedulePopup },
        },
        [
          _c(
            "div",
            {
              staticClass: "icon-schedule",
              class: { active: _vm.activePopover === "schedule" },
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/svg/calendar.svg") },
              }),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          ref: "container",
          staticClass: "marquee",
          on: {
            click: _vm.openNotificationPopup,
            mouseover: function ($event) {
              _vm.marqueePause = true
            },
            mouseleave: function ($event) {
              _vm.marqueePause = false
            },
          },
        },
        [
          _c(
            "div",
            {
              ref: "notificationTrigger",
              staticClass: "notification-trigger",
              class: { active: _vm.activePopover === "notification" },
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/svg/notification.svg") },
              }),
            ]
          ),
          _c(
            "MarqueeText",
            {
              attrs: {
                paused: _vm.marqueePause,
                duration: _vm.marqueeDuration,
              },
            },
            [
              _c("span", {
                staticClass: "marquee-spacer",
                style: { "margin-left": _vm.spacerWidth + "px" },
              }),
              _vm._l(_vm.announcements.slice(0, 5), function (nd, index) {
                return _c(
                  "span",
                  {
                    key: `${index}${nd.publishDateTime}`,
                    staticClass: "marquee-content",
                  },
                  [_vm._v(_vm._s(nd.message))]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }